import * as aes from "aes-cross";
import moment from "moment";
const key = "f3fe53b51d23eac8";

const key128iv = Buffer.from([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);

export function splitToken(data: any) {
  const bearer = data.split(" ");
  return bearer[1];
}

export function getDateFormat(date: any) {
  return moment(date).format("MMMM DD, yyyy HH:mm:ss");
}

export function EncryptData(data: any) {
  try {
    const encryptData = aes.enc(data, key, key128iv);

    return encryptData;
  } catch (error) {
    console.log("error encrypting");
  }
}

export function jsonParser(data: any) {
  try {
    return JSON.parse(data);
  } catch (error) {
    console.log("error when parsing", data, "actual error", error);
  }
}

export function DecryptData(data: any) {
  try {
    const decryptData = aes.dec(data, key, key128iv);

    return decryptData;
  } catch (error) {
    console.log("error decrypting");
  }
}

export function capitalizeEachWord(text: string) {
  if (!text || typeof text !== "string") return ""; // Handle empty or non-string values
  return text
    .split(" ") // Split the string into an array of words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join the words back into a single string
}
